import React, { useState } from 'react';
import { ShieldCheck, ChevronDown } from 'lucide-react';
export function GuaranteeDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="max-w-4xl mx-auto mt-4 px-4" data-id="element-132">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full bg-transparent border-t border-b border-[#e5e5e5] px-4 py-4 flex items-center justify-between cursor-pointer transition-colors group pt-[1px] pb-[1px]" aria-expanded={isOpen} data-id="element-133">
        <div className="flex items-center gap-3" data-id="element-134">
          <ShieldCheck className="w-5 h-5 text-gray-700 flex-shrink-0" data-id="element-135" />
          <span className="font-semibold text-left text-[14px] text-[#726D6D]" data-id="element-136">
            Garantía de Satisfacción de 7 Días
          </span>
        </div>
        <ChevronDown className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-137" />
      </button>

      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-138">
        <div className="px-4 pb-5 pt-4" data-id="element-139">
          <p className="text-gray-700 text-[15px] leading-relaxed mb-4" data-id="element-140">
            Con el{' '}
            <span className="font-bold text-gray-900" data-id="element-141">
              Sistema Completo de Comandos Eléctricos™
            </span>{' '}
            y los{' '}
            <span className="font-bold text-gray-900" data-id="element-142">8 Bonos Gratis</span>,
            tienes 7 días de prueba real en tu taller.
          </p>

          <p className="text-gray-700 text-[15px] leading-relaxed mb-4" data-id="element-143">
            Si dentro de los primeros 7 días sientes que el sistema NO te
            brinda:
          </p>

          <ul className="space-y-2.5 mb-5" data-id="element-144">
            {['Ideas claras para trabajar sin improvisar', 'Planos con medidas exactas y fáciles de entender', 'Proyectos reales que puedes ejecutar y cobrar', 'Mejoras concretas para organizar tu trabajo', 'Más confianza para cobrar lo que realmente vale tu servicio'].map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-145">
                <span className="text-gray-500 text-[15px] leading-none mt-0.5" data-id="element-146">
                  *
                </span>
                <span className="text-gray-600 text-[15px] leading-relaxed" data-id="element-147">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="text-gray-700 text-[15px] leading-relaxed" data-id="element-148">
            👉{' '}
            <span className="font-bold text-gray-900" data-id="element-149">
              Te devolvemos el 100% de tu dinero.
            </span>
          </p>
          <p className="text-gray-500 text-sm mt-1" data-id="element-150">
            Sin excusas. Sin condiciones. Sin explicaciones.
          </p>
        </div>
      </div>
    </div>;
}